"use client";

import { useEffect, useState } from "react";

interface Props {
  className?: string;
  mode?: "pulse" | "spark";
  /** Базовая непрозрачность в покое 0-1 */
  baseOpacity?: number;
  /** Средний интервал между вспышками в секундах */
  intervalSec?: number;
}

export default function HexLive({
  className,
  mode = "pulse",
  baseOpacity = 0.1,
  intervalSec = 35,
}: Props) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const schedule = () => {
      // Рандомный интервал ±30% от базового
      const jitter = intervalSec * (0.7 + Math.random() * 0.6);
      timeoutId = setTimeout(() => {
        setActive(true);
        // Снимаем active после анимации
        setTimeout(() => setActive(false), mode === "pulse" ? 2400 : 1800);
        schedule();
      }, jitter * 1000);
    };

    // Стартовая задержка чтобы не вспыхивало сразу при загрузке
    const initialDelay = 8000 + Math.random() * 12000;
    timeoutId = setTimeout(schedule, initialDelay);

    return () => clearTimeout(timeoutId);
  }, [mode, intervalSec]);

  return (
    <svg
      viewBox="0 0 100 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ opacity: baseOpacity }}
    >
      {/* Контур — статичный */}
      <polygon
        points="50,5 95,27.5 95,87.5 50,110 5,87.5 5,27.5"
        stroke="rgb(var(--accent))"
        strokeWidth="2"
        fill="none"
      />

      {/* Pulse — мягкое свечение по контуру */}
      {mode === "pulse" && (
        <polygon
          points="50,5 95,27.5 95,87.5 50,110 5,87.5 5,27.5"
          stroke="rgb(var(--accent))"
          strokeWidth="2"
          fill="none"
          style={{
            opacity: active ? 1.5 : 0,
            transition: active
              ? "opacity 0.3s ease-out"
              : "opacity 2.1s ease-in",
            filter: active ? "drop-shadow(0 0 6px rgb(var(--accent)))" : "none",
          }}
        />
      )}

      {/* Spark — точка пробегает по контуру */}
      {mode === "spark" && active && (
        <circle r="2.5" fill="rgb(var(--accent))">
          <animateMotion
            dur="1.8s"
            repeatCount="1"
            path="M 50,5 L 95,27.5 L 95,87.5 L 50,110 L 5,87.5 L 5,27.5 Z"
          />
          <animate
            attributeName="opacity"
            values="0;1;1;0"
            keyTimes="0;0.1;0.9;1"
            dur="1.8s"
            repeatCount="1"
          />
        </circle>
      )}
    </svg>
  );
}